var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMove = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M5 13h11.865l-3.633 4.36c-.354.424-.296 1.055.128 1.408.425.354 1.055.296 1.409-.128l5-6c.039-.047.058-.102.087-.154.024-.042.053-.078.071-.124.045-.115.072-.236.072-.358L20 12l-.001-.004c0-.122-.027-.243-.072-.358-.018-.046-.047-.082-.071-.124-.029-.052-.048-.107-.087-.154l-5-6C14.57 5.123 14.286 5 14 5c-.226 0-.453.076-.64.232-.424.353-.482.984-.128 1.408L16.865 11H5c-.552 0-1 .448-1 1s.448 1 1 1z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/move.3b909177.svg";
export { ForwardRef as ReactComponent };